export default __webpack_public_path__ + "static/media/java.2f6a3fb7.svg";